export const FLAG_GETTING_CHART_OF_ACCOUNTS = 'FLAG_GETTING_CHART_OF_ACCOUNTS';
export const GET_CHART_OF_ACCOUNTS = 'GET_CHART_OF_ACCOUNTS';
export const CLEAR_CHART_OF_ACCOUNTS = 'CLEAR_CHART_OF_ACCOUNTS';